import { Injectable, inject } from '@angular/core';

import { CookieList } from './cookie-list';
import { CookieService } from './cookie.service';

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class CookieDBService {
    private readonly cookieService = inject(CookieService);

    createList<T>(cookieName: string, expires?: Date): CookieList<T> {
        return new CookieList<T>(this.cookieService, cookieName, expires);
    }
}
